import PropTypes from 'prop-types';
// @mui
import { Box, Container, Stack, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
// ----------------------------------------------------------------------

interface IProps {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	size?: string;
}

export const CenteredContent = (props: IProps) => {
	return (
		<Box
			sx={{
				height: '100%',
				display: 'flex',
				flex: 1,
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			{props.children}
		</Box>
	);
};

export const CenteredNarrowContent = (props: IProps) => {
	const theme = useTheme();
	return (
		<Box maxWidth="100%">
			<Container maxWidth="sm" sx={{ [theme.breakpoints.down('sm')]: { padding: 0 } }}>
				{props.children}
			</Container>
		</Box>
	);
};

export const CenteredText = (props: IProps) => {
	return (
		<Box
			sx={{
				textAlign: 'center',
			}}
		>
			{props.children}
		</Box>
	);
};

export const PageHeaderActionsRow = styled(Stack)<IProps>({
	flexDirection: 'row',
	gap: '24px',
	'& .MuiFormControl-root': {
		width: '160px!important',
	},
});

export const TabsStack = styled(Stack)<IProps>({
	position: 'absolute',
	left: '15%',
	flexDirection: 'row',
	gap: '12px',
});

export const FadeIn = styled(Box)({
	animation: 'fadein 1s',
	'@keyframes fadein': {
		'0%': {
			opacity: 0,
		},
		'70%': {
			opacity: 0,
		},
		'100%': {
			opacity: 1,
		},
	},
});
